<!--<div class="flex flex-col min-h-screen">
  <app-header></app-header>
  <app-menubar></app-menubar>
    <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>-->
<div class="w-[100vw] h-[100vh]">
  <bnpp-indx-header></bnpp-indx-header>
  <bnpp-indx-menubar></bnpp-indx-menubar>
    <router-outlet></router-outlet>
  <bnpp-indx-footer></bnpp-indx-footer>
</div>

